import {
  FEE_PLAN,
  ITEM_PRICE_FEE_DISCOUNT,
  MINIMAL_FEE,
  MINIMAL_FEE_AMOUNT,
  PRIVATE_ITEM_FEE_DISCOUNT
} from './enum/market.js';

export const calculateItemDiscount = (price) => {
  if (price < ITEM_PRICE_FEE_DISCOUNT[0].min_price) {
    return 0;
  }
  return ITEM_PRICE_FEE_DISCOUNT.filter(i => i.min_price <= price).at(-1).discount;
};

export const calculateFeePercent = ({ price, is_private_sell }, user) => {
  let fee;
  let item_fee_discount = 0;

  const { custom_fee, plan_id } = user;

  const private_sell_modifier = is_private_sell === true ? PRIVATE_ITEM_FEE_DISCOUNT : 1;

  if (custom_fee) {
    fee = custom_fee;
  } else {
    const plan = FEE_PLAN.find(i => i.id === plan_id);
    if (!plan) {
      return false;
    }

    fee = plan.fee;
    item_fee_discount = calculateItemDiscount(price);
  }
  return Math.max(MINIMAL_FEE, Math.round((fee - item_fee_discount) * private_sell_modifier));
};
export const calculateItemFee = (item, user) => {
  const fee_percent = calculateFeePercent(item, user);
  if (!fee_percent) {
    return false;
  }
  const fee = Math.round(item.price * fee_percent);
  const fee_amount = Math.max(MINIMAL_FEE_AMOUNT, Math.round(fee / 10_000));
  return {
    fee_percent,
    fee_amount,
  }
}

